import { NgModule } from '@angular/core';
import { NimbusIconDirective } from './directives/nimbus-icon.directive';

@NgModule({
  declarations: [NimbusIconDirective],
  exports: [NimbusIconDirective],
})
export class NimbusIconModule {}
